import { render } from "./FilterProdutos.vue?vue&type=template&id=6468b574&scoped=true"
import script from "./FilterProdutos.vue?vue&type=script&lang=js"
export * from "./FilterProdutos.vue?vue&type=script&lang=js"

import "./FilterProdutos.vue?vue&type=style&index=0&id=6468b574&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6468b574"]])

export default __exports__